import { useEffect, useRef, useState } from 'react';
import './session-calendar.css';

export default function SessionCalendar({ selectedDate, setSelectedDate }) {
  const [today] = useState(new Date());
  const [daysInMonth, setDaysInMonth] = useState([]);
  const focusRef = useRef();

  useEffect(() => {
    // Set today as the initially selected date
    setSelectedDate(new Date());

    // Get all days in the current month
    const year = today.getFullYear();
    const month = today.getMonth();
    const lastDay = new Date(year, month + 1, 0);

    const days = [];
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push(new Date(year, month, i));
    }

    setDaysInMonth(days);
  }, [today]);

  const getDayName = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      timeZone: 'Asia/Kolkata',
    });
  };

  const isToday = (date) => {
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const isSelected = (date) => {
    return (
      selectedDate &&
      date.getDate() === selectedDate.getDate() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getFullYear() === selectedDate.getFullYear()
    );
  };

  const handleDateClick = (date) => {
    setSelectedDate(new Date(date));
    // getMeetings(date?.toISOString());
  };

  useEffect(() => {
    setTimeout(() => {
      focusRef?.current?.focus();
    }, 2000);
  }, []);

  return (
    <div className='calendar-container'>
      <div className='calendar-scroll'>
        {daysInMonth.map((date) => (
          <div
            key={date.getDate()}
            className={`day-item ${isSelected(date) ? 'selected-day' : ''}`}
            onClick={() => handleDateClick(date)}
          >
            <div className='date'>
              {String(date.getDate()).padStart(2, '0')}
            </div>
            <div className='day-name'>{getDayName(date)}</div>
            {isToday(date) && (
              <div className='dot'>
                <input
                  className='session-calendar-focus-inp'
                  type='text'
                  name=''
                  ref={focusRef}
                  id=''
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
